import React from "react";
import Image from "next/image";
import styled from "styled-components";
import {
  Visa,
  Mastercard,
  Amex,
  BankTransfer,
  DirectDebit,
  DinersClub,
  Diners,
  Discover,
  Paypal,
} from "@/Icons/PaymentIcons";
import amazonLogo from "@/Icons/PaymentIcons/images/am-logo.png";
import paypalLogo from "@/Icons/PaymentIcons/images/paypal-logo.png";
import rechnungLogo from "@/Icons/PaymentIcons/images/rechnung.png";

const Wrapper = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
  flexWrap: "wrap" as const,
  alignSelf: "end",
}));

const IconWrapper = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
  flexWrap: "wrap",
  "& svg": {
    height: "1.125rem",
    fill: theme.kallisto.color.text.static.textSecondary,
    color: theme.kallisto.color.text.static.textSecondary,
  },
}));

const ImgStyled = styled(Image)(() => ({
  height: "1.125rem",
  width: "auto",
  marginRight: "0.25rem",
}));

interface TourOperator {
  code?: string;
}

interface PaymentTypesProps {
  paymentTypes: string[];
  tourOperator?: TourOperator | null;
}

const PaymentTypes: React.FC<PaymentTypesProps> = ({
  paymentTypes,
  tourOperator,
}) => {
  if (!paymentTypes || paymentTypes.length === 0) {
    return null;
  }

  const isSolarTourOperator =
    tourOperator?.code === "SLR" || tourOperator?.code === "SLRD";

  return (
    <Wrapper>
      <IconWrapper>
        {paymentTypes.includes("BankTransfer") && <BankTransfer width="68px" />}
        {(paymentTypes.includes("VI") ||
          paymentTypes.includes("PaymentLink")) && <Visa width="27px" />}
        {(paymentTypes.includes("MC") ||
          paymentTypes.includes("MA") ||
          paymentTypes.includes("PaymentLink")) && (
          <Mastercard width="27.5px" />
        )}
        {paymentTypes.includes("AX") && <Amex width="27.5px" />}
        {paymentTypes.includes("Paypal") && <Paypal width="48px" />}
        {paymentTypes.includes("DC") && <DinersClub width="27px" />}
        {paymentTypes.includes("DirectDebitSEPA") && (
          <DirectDebit width="58px" />
        )}
        {paymentTypes.includes("PaymentLink") && isSolarTourOperator && (
          <>
            <ImgStyled src={amazonLogo} alt="Amazon Pay" height={18} />
            <ImgStyled src={paypalLogo} alt="PayPal" height={18} />
            <ImgStyled src={rechnungLogo} alt="Rechnung" height={18} />
          </>
        )}

        {paymentTypes.includes("PaymentLink") && (
          <>
            <Discover width="27px" />
            <Diners width="27px" />
          </>
        )}
      </IconWrapper>
    </Wrapper>
  );
};

export default PaymentTypes;
